import { useEffect } from 'react';
import { useSearchParams } from 'react-router';

import { setLeasingCompanyId, setProductType } from '@/store/app.slice';
import { useAppDispatch } from '@/store/store';

const LEASING_SESSION_KEY = 'leasing_session';

function parseLeasingSession(raw: string | null): {
  isLeasing: boolean;
  leasingCompanyId: string | null;
} {
  if (!raw) return { isLeasing: false, leasingCompanyId: null };
  if (raw === 'true') return { isLeasing: true, leasingCompanyId: null };
  try {
    const data = JSON.parse(raw);
    return {
      isLeasing: !!data.isLeasing,
      leasingCompanyId: data.leasingCompanyId ?? null
    };
  } catch {
    return { isLeasing: false, leasingCompanyId: null };
  }
}

export const useProductTypeInit = () => {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const productFromUrl = searchParams.get('product');
    const leasingCompanyIdFromUrl = searchParams.get('leasingCompanyId');
    const saved = parseLeasingSession(
      localStorage.getItem(LEASING_SESSION_KEY)
    );
    const isLeasing =
      productFromUrl === 'leasing' || (saved.isLeasing && !productFromUrl);
    const leasingCompanyId =
      leasingCompanyIdFromUrl ?? (isLeasing ? saved.leasingCompanyId : null);

    if (isLeasing) {
      localStorage.setItem(
        LEASING_SESSION_KEY,
        JSON.stringify({ isLeasing: true, leasingCompanyId })
      );
    } else {
      localStorage.removeItem(LEASING_SESSION_KEY);
    }

    dispatch(setProductType(isLeasing ? 'leasing' : productFromUrl || null));
    dispatch(setLeasingCompanyId(leasingCompanyId));
  }, [searchParams, dispatch]);
};
